module.exports = __webpack_public_path__ + "static/media/dangerous_products.91f3d837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/transport/dangerous_products.png
// module id = 151
// module chunks = 0 4